import { PropsWithChildren, useEffect } from "react";

import * as Sentry from "@sentry/react";
import { IntlProvider } from "react-intl";

export const SentryIntlProvider = (
    props: PropsWithChildren<{
        locale: string;
        messages: Record<string, string>;
    }>
) => {
    useEffect(() => {
        Sentry.init({
            dsn: "https://a48c5247caec7a2e0ad0b8ef86376ee1@o55978.ingest.sentry.io/4505919063457792",
            environment: process.env["CLIENT_LIBRARY_ENV"],
            integrations: [
                new Sentry.BrowserTracing({
                    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
                    tracePropagationTargets: [
                        "localhost",
                        /^https:\/\/atlassian\.com/
                    ]
                })
            ],
            // Performance Monitoring
            tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
            enabled: process.env["CLIENT_LIBRARY_ENV"] !== "local"
        });
    }, []);

    return (
        <Sentry.ErrorBoundary
            //@ts-ignore
            beforeCapture={(scope) => {
                scope.setTag("service", "wac-web-fe");
            }}
        >
            <IntlProvider locale={props.locale} messages={props.messages}>
                {props.children}
            </IntlProvider>
        </Sentry.ErrorBoundary>
    );
};
